module.exports = __webpack_public_path__ + "static/img/rank_76.76efe52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_76.png
// module id = Cnrt
// module chunks = 0